import { z } from 'zod/v4';

export const BOOLEAN_WITH_DEFAULT = ['default', 'true', 'false'] as const;

export type BoolanWithDefault = (typeof BOOLEAN_WITH_DEFAULT)[number];

export const BooleanWithDefaultSchema = z.enum([...BOOLEAN_WITH_DEFAULT]);
